import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { allAccountsGroupedByProviderSelector } from "./allAccountsGroupedByProviderSelector";
import { accountsGroupedByProviderAndOrgCombiner } from "../../combiners/accountsGroupedByProviderAndOrgCombiner";

export const allAccountsGroupedByProviderAndOrgSelector =
  createDraftSafeSelector(
    [allAccountsGroupedByProviderSelector],
    accountsGroupedByProviderAndOrgCombiner,
  );
